var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconYt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-yt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_14",
    "data-name": "Rettangolo 14",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_317714_video_youtube_icon",
    "data-name": "317714_video_youtube_icon",
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sottrazione_1",
    "data-name": "Sottrazione 1",
    d: "M9,14H9c-.192,0-4.72-.052-6.119-.2-.068-.014-.149-.025-.243-.037A2.533,2.533,0,0,1,.9,12.948,4.6,4.6,0,0,1,.18,10.973C.173,10.907,0,9.329,0,7.751V6.242C0,4.665.173,3.087.18,3.021A4.615,4.615,0,0,1,.9,1.044,2.367,2.367,0,0,1,2.588.215L2.7.2C5.189,0,8.958,0,9,0H9c.038,0,3.807,0,6.3.2l.109.012a2.367,2.367,0,0,1,1.695.83,4.609,4.609,0,0,1,.715,1.977c.007.066.18,1.645.18,3.222v1.51c0,1.577-.173,3.155-.18,3.221a4.6,4.6,0,0,1-.715,1.975,2.373,2.373,0,0,1-1.688.83l-.116.013C12.814,13.99,9.038,14,9,14ZM6.752,3.5v7L12.379,7,6.752,3.5Z",
    transform: "translate(0 4)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYt);
export default __webpack_public_path__ + "static/media/icon-yt.811829640667182316ff5c688c252741.svg";
export { ForwardRef as ReactComponent };